import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  line-height: 3;
`;
